module.exports = __webpack_public_path__ + "static/media/logo.049d2136.png";